// List of mobile-money providers supported by the checkout
export const MOBILE_MONEY_PROVIDERS = Object.freeze([
  // Wave is currently available to customers
  Object.freeze({
    checkoutLabelKey: "payment.payNowWithWave",
    enabled: true,
    id: "WAVE",
    inputId: "wave",
    name: "Wave",
    unavailableMessageKey: "error.wavePaymentUnavailable",
  }),
  // Orange Money is prepared for future use but remains hidden while disabled
  Object.freeze({
    checkoutLabelKey: "payment.payNowWithOrangeMoney",
    enabled: false,
    id: "ORANGE_MONEY",
    inputId: "orangeMoney",
    name: "Orange Money",
    unavailableMessageKey: "error.checkoutFailed",
  }),
]);

// Return only mobile-money providers currently available to customers
export const getEnabledMobileMoneyProviders = function () {
  return MOBILE_MONEY_PROVIDERS.filter(({ enabled }) => enabled);
};

// Find a mobile-money provider using its payment method value
export const getMobileMoneyProvider = function (providerId) {
  return MOBILE_MONEY_PROVIDERS.find(({ id }) => id === providerId);
};
